import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import moment from 'moment'

// import Chart from 'chart.js'
import { Bar, Doughnut, Line } from 'react-chartjs-2'

import {
  Grid, Card, CardContent,
  Paper, Button, Table, TableHead,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import {
  Remove, ArrowDownward as ArrowDown,
  ArrowUpward as ArrowUp
} from '@material-ui/icons'

// import Skeleton from '@material-ui/lab/Skeleton'

// import { onQuickFilter, handleFilter } from '../../../utils'

import {
  setFilter, setAllChecked, setStatusSnack, setSelectedReport
} from '../../../redux/actions/select'

import { getViolations } from '../../../redux/actions/violations'

import { withStyles } from '@material-ui/core/styles'

import { formatStatusClass, getViolationIndex } from '../../../utils'

import { defaultFilter } from '../../../utils/variables'

import queryString from 'query-string'

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

/**
 * Charts are built using react-chartjs-2, a react wrapper for ChartJS2
 * https://github.com/jerairrest/react-chartjs-2
 * https://www.npmjs.com/package/react-chartjs-2
**/
const DashboardView = (props) => {
  const {
    barChartConfig, pieChartConfig, lineChartConfig, stackedChartConfig,
    dailyPercentage, weeklyPercentage,
    recentCaptureNumber, topProblemUsers, success, useStyles
  } = props

  const parsedProps = queryString.parse(props.location.search)

  const dispatch = useDispatch()
  const classes = useStyles()
  const View = useSelector(state => state.userSettings.general.defaultView)

  const Filter = useSelector(state => state.selection.Filter)
  const Page = useSelector(state => state.selection.Page)
  const PageCaptureLimit = useSelector(state => state.selection.PageCaptureLimit)
  const Captures = useSelector(state => state.violations.violations.captures)

  const CaptureNum = parseInt(parsedProps.capture, 10)
  const currentView = parsedProps.view

  const [filterData] = useState({ ...Filter })
  useEffect(() => { dispatch(getViolations(Filter)) }, [dispatch, Filter])

  const handleUserProblemFilter = (user) => {
    const filter = { ...defaultFilter, captureAreas: ['P'], usernames: [user.key], refresh: true, violationIDs: [], includeViolationIDs: [] }
    dispatch(setFilter(filter))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  const handleRecentCaptures = () => {
    const today = moment().format('x')
    const currentDayTimestamp = parseInt(today, 10)

    const yesterday = moment().add(-1, 'days').format('x')
    const previousDayTimestamp = parseInt(yesterday, 10)

    const filter = { ...filterData, startDate: previousDayTimestamp, endDate: currentDayTimestamp, refresh: true, violationIDs: [], includeViolationIDs: [] }

    dispatch(setFilter(filter))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  const setArrowCurrentDay = () => {
    if (typeof weeklyPercentage === 'number' && Math.sign(weeklyPercentage) === 1) {
      return (
        <ArrowUp className={classes.redArrow} />
      )
    }

    if (typeof weeklyPercentage === 'number' && Math.sign(weeklyPercentage) === -1) {
      return (
        <ArrowDown className={classes.greenArrow} />
      )
    }

    return (
      <Remove className={classes.blueLine} />
    )
  }

  const setArrowDaily = () => {
    if (typeof dailyPercentage === 'number' && Math.sign(dailyPercentage) === 1) {
      return (
        <ArrowUp className={classes.redArrow} />
      )
    }

    if (typeof dailyPercentage === 'number' && Math.sign(dailyPercentage) === -1) {
      return (
        <ArrowDown className={classes.greenArrow} />
      )
    }

    return (
      <Remove className={classes.blueLine} />
    )
  }

  const setReports = async () => {
    if (currentView !== 'single') {
      dispatch(setAllChecked(false))
      dispatch(setSelectedReport('users'))
      props.history.push('/reports')
    } else {
      const captureIx = getViolationIndex({ captureNum: CaptureNum, pageLimit: PageCaptureLimit, page: Page, currentView })

      if (typeof captureIx === 'number' && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setSelectedReport('users'))
        props.history.push('/reports')
      }
    }
  }

  return (
    <Grid container direction='row' justify='center'>
      <Grid item sm={12} md={10} xl={8} className='px-4'>
        <Card style={{ padding: '6px', backgroundColor: '#ffffff' }}>
          <CardContent>
            <Grid container direction='column' spacing={3} className='w-100 h-100 m-auto' justify='center'>

              {/* Date & Title Start */}
              <Grid container item direction='row' className='w-100 mb-3' justify='space-between' alignItems='center'>
                <Grid item>
                  <h4 className='unselectable' style={{ color: '#777777', fontWeight: 'bold' }}>{moment().format('dddd')} - {moment().format('LL')}</h4>
                </Grid>

                <Grid item>
                  <Grid item container direction='row'>
                    <h1 className='unselectable' style={{ marginRight: '.6rem', color: '#4190FF', fontWeight: 'bold' }}>LearnSafe</h1>
                    <h1 className='unselectable' style={{ color: '#A4D163', fontWeight: 'bold' }}>Dashboard</h1>
                  </Grid>
                </Grid>
              </Grid>
              {/* Date & Title End */}

              {/* Top Row Start */}
              <Grid container item direction='row' className='w-100 mb-0 mx-auto' justify='center' spacing={4}>
                {/* Capture Info Start */}
                <Grid item lg={4} style={{ width: '100%' }}>
                  <Grid container item direction='column' spacing={2} className='m-auto h-100 w-100'>
                    <Grid item container direction='row' className='px-0 pt-0'>
                      <Paper elevation={2} className={classes.capturePaper}>
                        <Grid container direction='column'>

                          <Grid item container direction='row'>
                            <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', marginBottom: '1rem', fontSize: '1rem' }}>Captures in Last 24 Hours</h5>
                          </Grid>

                          <Grid item container direction='row' justify='center'>
                            <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              {/* <h1 className='badge badge-primary my-auto mx-auto' style={{ fontSize: '1.9rem' }}>{recentCaptureNumber}</h1> */}
                              <Button
                                className={classes.blueBtn}
                                style={{ fontSize: '1.3rem', fontWeight: 'bold', color: 'white' }}
                                onClick={(e) => { e.preventDefault(); handleRecentCaptures() }}
                                disabled={recentCaptureNumber === 0}
                              >
                                {recentCaptureNumber}
                              </Button>
                            </Grid>
                            {/* <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              <Button
                                className={classes.greenBtn}
                                onClick={(e) => { e.preventDefault(); setCaptures() }}
                              >
                                View
                              </Button>
                            </Grid> */}
                          </Grid>

                        </Grid>
                      </Paper>
                    </Grid>

                    <Grid item className='px-0' container direction='row'>
                      <Paper elevation={2} className={classes.weekTrendPaper}>
                        <Grid container direction='column'>

                          <Grid item container direction='row'>
                            <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>{moment().format('dddd')} Trend</h5>
                          </Grid>

                          <Grid container item direction='row' justify='center'>
                            <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              <h1 className='badge badge-primary my-auto mx-auto unselectable' style={{ fontSize: '1.7rem' }}>{`${Math.abs(weeklyPercentage) || 0}%`}</h1>
                            </Grid>
                            <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              {setArrowCurrentDay()}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>

                    <Grid item className='px-0' container direction='row'>
                      <Paper elevation={2} className={classes.dailyTrendPaper}>
                        <Grid container direction='column'>

                          <Grid item container direction='row'>
                            <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>Daily Trend</h5>
                          </Grid>

                          <Grid container item direction='row' justify='center'>
                            <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              <h1 className='badge badge-primary my-auto mx-auto unselectable' style={{ fontSize: '1.7rem' }}>{`${Math.abs(dailyPercentage) || 0}%`}</h1>
                            </Grid>
                            <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                              {setArrowDaily()}
                            </Grid>
                          </Grid>

                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Capture Info End */}

                {/* Problem Violation Info Start */}
                <Grid item lg={4} style={{ width: '100%' }}>
                  <Paper elevation={2} className={classes.problemPaper}>
                    <Grid item>
                      <h5
                        className='unselectable'
                        style={{ fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}
                      >
                        Top Problem Captures by User
                      </h5>
                    </Grid>

                    <Grid item>
                      <Button
                        className={classes.greenBtn}
                        style={{ fontSize: '.8rem' }}
                        onClick={(e) => { e.preventDefault(); setReports() }}
                      >
                        View Full Report
                      </Button>
                    </Grid>

                    <Grid item>
                      <TableContainer className={classes.tableContainer}>
                        <Table className={classes.table} size='small' padding='none' aria-label='users-table'>
                          <TableHead>
                            <TableRow>
                              <TableCell className={`${classes.tableHeadText} unselectable`}>User</TableCell>
                              <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Captures</TableCell>
                              <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Total Severity</TableCell>
                            </TableRow>
                          </TableHead>
                          {
                            success === true
                              ? (
                                <TableBody>
                                  {[...topProblemUsers].map((user, index) => (
                                    <StyledTableRow key={index}>
                                      <TableCell
                                        className={classes.tableText}
                                        component='th'
                                        scope='row'
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => { e.preventDefault(); handleUserProblemFilter(user) }}
                                      // onClick={(e) => { e.preventDefault(); handleQuickFilter({ username: user.key }) }}
                                      >
                                        {user.key}
                                      </TableCell>
                                      <TableCell className={`${classes.tableText} unselectable`} align='right'>{user.doc_count}</TableCell>
                                      <TableCell className={`${classes.tableText} unselectable`} align='right'>{user.total_severity.value}</TableCell>
                                    </StyledTableRow>
                                  ))}
                                </TableBody>)
                              : (<></>)
                          }
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Paper>
                  {/* <Paper elevation={2} style={{ padding: '10px', marginRight: '20px', marginBottom: '2rem', height: '90%' }}>
                    <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', marginBottom: '1rem', fontSize: '1rem' }}>Total Problem Violations</h5>
                    <Grid container direction='row' className='mx-auto my-auto'>
                      <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                        <h1 className='badge badge-primary my-auto mx-auto' style={{ fontSize: '1.9rem' }}>{totalProblemCount}</h1>
                      </Grid>
                      <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                        <Button
                          className={classes.greenBtn}
                          onClick={(e) => { e.preventDefault(); setCaptures() }}
                        >
                          View
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item style={{ height: '27%' }}>
                  <Paper elevation={2} style={{ padding: '10px', marginRight: '20px', marginBottom: '1rem', height: '90%' }}>
                    <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', marginBottom: '1rem', fontSize: '1rem' }}>Problem Violations in Last 24 Hours</h5>
                    <Grid container direction='row' className='mx-auto my-auto'>
                      <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                        <h1 className='badge badge-primary my-auto mx-auto' style={{ fontSize: '1.9rem' }}>{yesterdayProblemCount}</h1>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item style={{ height: '27%' }}>
                  <Paper elevation={2} style={{ padding: '10px', marginRight: '20px', marginBottom: '1rem', height: '90%' }}>
                    <h5 className='unselectable' style={{ fontWeight: 'bold', color: '#777777', marginBottom: '1rem', fontSize: '1rem' }}>Problem Violations in Last Week</h5>
                    <Grid container direction='row' className='mx-auto my-auto'>
                      <Grid item container xs={6} className='my-auto mx-auto' justify='center'>
                        <h1 className='badge badge-primary my-auto mx-auto' style={{ fontSize: '1.9rem' }}>{lastWeekProblemCount}</h1>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid> */}
                </Grid>
                {/* Problem Violation Info End */}

                {/* Weekly Trend Chart Start */}
                <Grid item lg={4} style={{ width: '100%' }}>
                  <Paper elevation={2} className={classes.weekTrendGraph}>
                    <Grid container direction='column'>

                      <Grid container item>
                        <h5 className='unselectable' style={{ marginBottom: '1.5rem', fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>Weekly Trend</h5>
                      </Grid>

                      <Grid container item>
                        {
                          success === true
                            ? (
                              <Line
                                data={lineChartConfig}
                                // width={100}
                                // height={null}
                                // width={null}
                                height={260}
                                options={{
                                  // aspectRatio: 1.25,
                                  // responsive: true,
                                  maintainAspectRatio: false,
                                  legend: { position: 'bottom' }
                                }}
                              />)
                            : (<></>)
                        }
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>
                {/* Weekly Trend Chart End */}
              </Grid>
              {/* Top Row End */}

              {/* Bottom Row Start */}
              <Grid container item direction='row' className='w-100 m-auto' spacing={2}>
                <Grid item lg={4} style={{ width: '100%' }}>
                  <Paper elevation={2} className={classes.captureNumPaper}>
                    <Grid container direction='column'>

                      <Grid container item direction='row'>
                        <h5 className='unselectable' style={{ marginBottom: '1.5rem', fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>Captures by Last 7 Days</h5>
                      </Grid>

                      <Grid container item direction='row'>
                        {
                          success === true
                            ? (
                              <Bar
                                data={barChartConfig}
                                // width={100}
                                height={250}
                                options={{
                                  // responsive: true,
                                  maintainAspectRatio: false,
                                  legend: { position: 'bottom' }
                                }}
                              />)
                            : (<></>)
                        }
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>

                <Grid item lg={4} style={{ width: '100%' }}>
                  <Paper elevation={2} className={classes.categoryPaper}>
                    <Grid container direction='column'>

                      <Grid container item direction='row'>
                        <h5 className='unselectable' style={{ marginBottom: '1.5rem', fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>Top 5 Recent Categories</h5>
                      </Grid>

                      <Grid container item direction='row'>
                        {
                          success === true
                            ? (
                              <Doughnut
                                data={pieChartConfig}
                                // width={100}
                                height={250}
                                options={{
                                  // responsive: true,
                                  maintainAspectRatio: false,
                                  legend: { position: 'bottom' },
                                  cutoutPercentage: 25
                                }}
                              />)
                            : (<></>)
                        }
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>

                <Grid item lg={4} style={{ width: '100%' }}>
                  <Paper elevation={2} className={classes.severityPaper}>
                    <Grid container direction='column'>

                      <Grid container item direction='row'>
                        <h5 className='unselectable' style={{ marginBottom: '1.5rem', fontWeight: 'bold', color: '#777777', fontSize: '1rem' }}>Recent Severity Analysis</h5>
                      </Grid>

                      <Grid container item direction='row'>
                        {
                          success === true
                            ? (
                              <Bar
                                data={stackedChartConfig}
                                // width={100}
                                height={250}
                                options={{
                                  // responsive: true,
                                  maintainAspectRatio: false,
                                  legend: { position: 'bottom' },
                                  scales: {
                                    xAxes: [{ stacked: true, gridLines: { display: false } }],
                                    yAxes: [{ stacked: true, ticks: { beginAtZero: true }, type: 'linear' }]
                                  }
                                }}
                              />)
                            : (<></>)
                        }
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>

              </Grid>
              {/* Bottom Row End */}

            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default withRouter(DashboardView)
